import React from 'react';
import { Multiselect } from 'multiselect-react-dropdown';
import { PropertiesStatus } from 'src/pages/Reporting/components/PropertiesStatus/PropertiesStatus';
import { IProperty, SelectedValue } from 'src/pages/Reporting/ReportingFormTypes';
import './PropertyMultiSelectSection.scss';

export interface PropertyMultiSelectSectionProps {
  propertyOptions: IProperty[];
  selectedValues: SelectedValue[];
  showRequiredMarker: boolean;
  isLoadingProperties: boolean;
  propertiesError: string | null;
  onSelectedValuesChange: (nextSelectedValues: SelectedValue[]) => void;
}

export const PropertyMultiSelectSection = ({
  propertyOptions,
  selectedValues,
  showRequiredMarker,
  isLoadingProperties,
  propertiesError,
  onSelectedValuesChange,
}: PropertyMultiSelectSectionProps) => {
  return (
    <div className="property-multiselect-section">
      <div className="property-multiselect-section__header">
        <div className="reporting__heading">SELECT PROPERTIES</div>
        {showRequiredMarker && <div className="picker__required" />}
      </div>

      <PropertiesStatus
        isLoading={isLoadingProperties}
        error={propertiesError}
        propertiesCount={propertyOptions.length}
      />

      <Multiselect
        options={propertyOptions}
        displayValue="name"
        selectedValues={selectedValues}
        placeholder="Select Property"
        onSelect={onSelectedValuesChange}
        onRemove={onSelectedValuesChange}
      />
    </div>
  );
};
